import { uniqueId } from 'lodash';
import { AdditionalResourceStatus } from 'redux/schemas/models/help-options';
import type { ResourceFile, FormResourceFile } from '../types';

export { formatFileSize } from 'shared/react-utils';

export const getFileExtension = (fileName: string): string => {
  const parts = fileName.split('.');
  if (parts.length > 1) {
    return `.${parts.pop()?.toLowerCase()}`;
  }
  return '';
};

export const getFileExtensions = (files: File[]): string[] => files.map((file) => getFileExtension(file.name));

export const createResourceFromFile = (file: File): ResourceFile => {
  const id = uniqueId('resource_');
  return {
    id,
    uniqueId: id,
    fileName: file.name,
    fileSize: file.size,
    contentType: file.type,
    url: '',
    resourceId: undefined,
    status: AdditionalResourceStatus.UPLOADING,
    uploadedFile: file,
  };
};

export const toFormResource = (resource: ResourceFile): FormResourceFile => {
  const { status, uploadedFile, ...formResource } = resource;
  return formResource;
};

export const toFormResources = (resources: ResourceFile[]): FormResourceFile[] => resources.map(toFormResource);

export const fromFormResource = (
  formResource: FormResourceFile,
  status: AdditionalResourceStatus = AdditionalResourceStatus.SUCCESS,
): ResourceFile => ({
  ...formResource,
  status,
  uploadedFile: undefined,
});

export const fromFormResources = (
  formResources: FormResourceFile[],
  status: AdditionalResourceStatus = AdditionalResourceStatus.SUCCESS,
): ResourceFile[] => formResources.map((formResource) => fromFormResource(formResource, status));

